<template>
<div>
  <vs-table :data="yearlyRates" class="noscroll">
    <template slot="thead" >
      <vs-th width="200px">{{ $t("CashFlow.YearlyFxRate.Currency")}}</vs-th>
      <vs-th width="110px" style="min-width: 110px;" v-for="(year, index) in years" :key="index">
        <span>
          {{ year }}
        </span>
      </vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr v-for="d in data" :key="d.currency">
        <vs-td :data="d.currency">
          <vs-row>
            <vs-col>
              {{ getCurrencyName(d.currency) }}
            </vs-col>
          </vs-row>
        </vs-td>
        <vs-td :data="d.values[index].rate" align="center" v-for="(value, index) in d.values" :key="index">
          <ValidationProvider :name="$t('CashFlow.YearlyFxRate.Rate')" immediate rules="required|decimal|min_value:0" v-slot="{ errors }">
            <vs-input :disabled="readOnly" v-model="d.values[index].rate" class="w-full" v-if="d.values[index].id!=null" v-on:change="onEditRate($event, d.values[index].id)" :title="getOriginalRateDesc(d.values[index].originalRate)" />
            <span v-if="d.values[index].id==null">N/A</span>
            <validation-message>{{ errors[0] }}</validation-message>
          </ValidationProvider>
        </vs-td>
      </vs-tr>
    </template> 
  </vs-table>
</div>

</template>
<script>

import {
  ValidationMessage
} from "@/app/shared/components";

export default {
  /* eslint-disable vue/no-unused-components */
  components: {
    ValidationMessage
  },
  props: {
    readOnly : {
      type: Boolean,
      default: false
    },
    yearlyRates: {
      type: Array,
      default: () => {}
    }
  },
  data() {
    return {
      isMounted: false,
      context: { componentParent: this }
    };
  },

  computed: {
    years () {
      return this.$props.yearlyRates.map(item => item.values.map(v => v.year))[0];
    }
  },

  methods: {
    getCurrencyName(currency) {
      return this.$t("CashFlow.Currency." + currency);
    },
    getOriginalRateDesc(value) {
      return this.$t("CashFlow.YearlyFxRate.OriginalRate") + value;
    },
    onEditRate(event, yearlyFxRateId) {
      const value = event.target.value;
      if (value === null || value === "") {
        return;
      }

      if (Number(value) === 0) {
        this.deleteRate(yearlyFxRateId);
        return;
      }

      this.$cqrsPost('cashflow/lom/yearlyFxRateTemplates/EditYearlyRate', { 
        id: yearlyFxRateId,
        rate: value
      }).finally(() => {
        this.$vs.loading.close();
      });
    },
    deleteRate(yearlyFxRateId) {
      this.$cqrsPost('cashflow/lom/yearlyFxRateTemplates/DeleteYearlyRate', { 
        id: yearlyFxRateId
      }).then(() => {
        const flattenedYearlyRates = this.yearlyRates.flatMap(x => x.values);
        const nowDeletedRate = flattenedYearlyRates.find(x => x.id === yearlyFxRateId);
        nowDeletedRate.id = null;
        nowDeletedRate.rate = null;
      }).catch((response) => {
        console.log(response);
      });
      
    }
  }
};
</script>

<style lang="scss">
  .noscroll {
    overflow: initial !important;
  }

</style>